import React from 'react';
import './devProjects.css';
import LogoVPP from '../../images/LogoVPP.png'; // Tell Webpack this JS file uses this image
import LogoFoohealli from  '../../images/LogoFoohealli.png'
import LogoPTU from  '../../images/LogoPlanTuU.png'
import LogoBH from  '../../images/dblogo.png'
import Logo3G from  '../../images/Logo3G.png'
import CardProject from '../../components/CardProject';

export default function DevProjects()
{
    return (
      <div className="dev-projects">
       <div>
        <div className="wrapper-cards">
        <p className="title-page">Web, mobile apps and VR</p>
          <p className="description-page">See my work in web applications, using ReactJS, NodeJS, HTML5, CSS3, MongoDB and Firebase</p>
          <br/>
          <div className="tz-gallery">
              <div className="container-projects">
                   <CardProject 
                        image={LogoVPP}
                        title="SII Cuidamos" 
                        description="This application exposes public investment projects in Colombia in order that citizens can make a correct follow-up to the development and implementation of them." 
                        web="http://www.siicuidamos.org/" 
                        github="https://github.com/siicuidamos/sii-cuidamos"
                    />
                   <CardProject 
                        image={LogoFoohealli}
                        title="Foohealli" 
                        description="Foohealli is an application that seeks to improve communication between doctors, nutritionists and patients in order to achieve successful nutritional treatments." 
                        web="https://foohealli-app.herokuapp.com/" 
                        github="https://github.com/VivianGomez/canal-nutricion"
                    />
                  <CardProject 
                        image={LogoPTU}
                        title="Plan Tú U" 
                        description="This application seeks to retain graduates Uniandinos through a system of points from which they obtain benefits. The application allows them to see the benefits they can obtain and manage their points, among other feature." 
                        web="https://plan-tu-u.herokuapp.com/" 
                        github="https://github.com/gabrielpintop/plan-tu-u"
                    />
                    <CardProject 
                        image={LogoBH}
                        title="BHelp-Dashboard" 
                        description="Dashboard created to understand the users behavior in the mobile application BHelp. For this, the web app consumes the database and analytics of the mobile app. After, these data is showed in different interactive graphs." 
                        web="http://bhelpdb.herokuapp.com/" 
                        github="https://github.com/VivianGomez/bhelp-dashboard"
                    />
                    <CardProject 
                        image={Logo3G}
                        title="Tres Gatos Cervecería" 
                        description="Web site to show and sell the products of Tres Gatos Cervecería Artesanal." 
                        web="https://tresgatoscerveceria.com/" 
                        github="https://github.com/VivianGomez/canal-nutricion"
                    />
              </div>
            </div>
            <center>
              <div className="cont-video">
                <p className="sub-title-page">Working with VR</p>
                <p className="sub-description-page">Working as researcher at Universidad de los Andes, I did ADD Scape, an VR app to help in the treatment Attention Deficit Hyperactivity Disorder (ADHD). This app, seeks to determine the status and progress of each child, through a virtualization of traditional games, accompanied by more fun components. Thanks to the immersive environment (through VR) and the use of the "Escape Room" game type, as a motivator for children.</p>
                <div className="container-iframe">
                  <iframe title="ADDScape" className="responsive-iframe" width="900" height="506" src="https://www.youtube.com/embed/mbAbzxoia-Y?mute=1" frameBorder="0" allowFullScreen></iframe>
                </div>
              </div> 
            </center>
          </div>          
        </div>
      </div>
    )
}